/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { getProgressionJudgementLabel } from 'linced-app/helpers/progression-judgement-label';
import {
  attributeBindings,
  classNameBindings,
  classNames,
} from '@ember-decorators/component';

@classNames('progress-dot')
@classNameBindings('isInterim', 'judgement')
@attributeBindings('dataTitle:data-title')
export default class ProgressDot extends Component {
  @service
  strings;

  @computed('progression.milestone.isInterim')
  get isInterim() {
    return this.get('progression.milestone.isInterim') ? 'interim' : '';
  }

  @computed('progression.judgement')
  get judgement() {
    return `colours-progress--${this.progression.judgement}`;
  }

  @computed('progression.{judgement,milestone.isInterim}')
  get dataTitle() {
    let title = getProgressionJudgementLabel(
      this.progression.judgement,
      { capitalize: true },
      this.strings,
    );

    if (this.get('progression.milestone.isInterim')) {
      title += ' (interim)';
    }
    return title;
  }
}
